import React from "react"
import {ContainerMaxWidth} from "models/SearchState"
import {PlpContainerComponent} from "../../components"

interface SeparatorComponentProps {
    children: NonNullable<React.ReactNode>
    loadPageFromUrl: (url: string) => void
    containerMaxWidth: ContainerMaxWidth
    testId: string
}

export interface PlpContainerProps {
    children: NonNullable<React.ReactNode>
}

export const StandardPlpContainer = ({children, containerMaxWidth, testId}: SeparatorComponentProps) => {
    return (
        <PlpContainerComponent
            maxWidth={containerMaxWidth.fixedMaxWidth}
            {...(containerMaxWidth.customMaxWidth ? {sx: {maxWidth: containerMaxWidth.customMaxWidth}} : {})}
            id="plp"
            data-testid={testId}
        >
            {children}
        </PlpContainerComponent>
    )
}

export default StandardPlpContainer
